import { IResourceComponentsProps, useNavigation } from "@pankod/refine-core";
import {
  Button,
  Col,
  Create,
  Row,
  SaveButton,
  useForm,
} from "@pankod/refine-antd";
import { IContents } from "interfaces";
import { CampaignForm } from "components/forms";

export const CampaignCreate: React.FC<IResourceComponentsProps> = () => {
  const { goBack } = useNavigation();
  const { formProps, saveButtonProps, queryResult } = useForm<IContents>();
  return (
    <Create
      title="Criar campanha"
      footerButtons={() => (
        <Row gutter={[6, 6]}>
          <Col>
            <Button onClick={() => goBack()} style={{ minWidth: "92px" }}>
              Cancelar
            </Button>
          </Col>

          <Col>
            <SaveButton
              {...saveButtonProps}
              icon={null}
              style={{ minWidth: "92px" }}
            >
              Salvar
            </SaveButton>
          </Col>
        </Row>
      )}
    >
      <CampaignForm formProps={formProps} queryResult={queryResult} />
    </Create>
  );
};
